<script setup>
import FlashMessage from '@/components/shared/core/FlashMessage.vue'
import {useFlashMessages} from '@/composables/use-flash-messages.js'

//Get flash messages
const {flashMessages, hideFlashMessage} = useFlashMessages()

//This is needed to prevent https://github.com/vuejs/vue/issues/11654
const beforeLeave = el => {
  const {marginLeft, marginTop, width, height} = window.getComputedStyle(el)
  el.style.left = `${el.offsetLeft - parseFloat(marginLeft, 10)}px`
  el.style.top = `${el.offsetTop - parseFloat(marginTop, 10)}px`
  el.style.width = width
  el.style.height = height
}
</script>
<template>
  <TransitionGroup
    tag="div"
    :class="$style.container"
    :move-class="$style.move"
    :enter-active-class="$style.from"
    :leave-active-class="$style.leaveActive"
    :enter-from-class="$style.to"
    :leave-to-class="$style.to"
    hide-empty
    @before-leave="beforeLeave"
  >
    <FlashMessage
      v-for="message in flashMessages"
      :key="message.id"
      :text="message.text"
      :type="message.type"
      :is-static="!message.timeout"
      @close="hideFlashMessage(message.id)"
    />
  </TransitionGroup>
</template>

<style module lang="scss">
.container {
  position: fixed;
  top: 0;
  right: 0;
  width: 100vw;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 1rem;
  padding: 2rem;
  pointer-events: none;
}
.move, .from, .leaveActive {
  transition: all var(--transition-cubic);
}
.to {
  opacity: 0;
  transform: translate(5rem, 0);
}
.leaveActive {
  position: absolute;
}
</style>
